// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-layout {
  display: grid;
  grid-template-columns: var(--ops-sidebar-width, 280px) minmax(0, 1fr);
  gap: 14px;
  align-items: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.ops-sidebar {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(143, 155, 175, 0.16);
  border-radius: 22px;
  padding: 16px 10px;
  box-shadow: 0 10px 24px rgba(52, 62, 94, 0.06);
  backdrop-filter: blur(12px);
}

.ops-sidebar-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.ops-sidebar-footer {
  flex: 0 0 auto;
  padding-top: 12px;
  margin-top: 8px;
  border-top: 1px solid rgba(143, 155, 175, 0.14);
}

.ops-sidebar-logout {
  width: 100% !important;
  justify-content: center !important;
}

.ops-mobile-nav {
  display: none;
}

.ops-module-nav-label {
  padding: 2px 12px 10px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #5e6475;
}

.ops-module-nav-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ops-module-link {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  text-decoration: none;
  color: #2c3140;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.ops-module-link:hover {
  background: rgba(236, 240, 252, 0.98);
  box-shadow: inset 3px 0 0 #b8aef0;
  text-decoration: none;
  color: #2c3140;
}

.ops-module-dot {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 0.78rem;
}

.ops-module-name {
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: normal;
  overflow: visible;
  word-break: break-word;
  padding-top: 4px;
}

.ops-main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.ops-dash {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: auto auto minmax(0, 1fr);
  grid-template-areas:
    "hero hero hero queue"
    "kpis kpis kpis queue"
    "enroll enroll right right";
  gap: 10px;
  overflow: hidden;
}

.ops-dash-hero {
  grid-area: hero;
}

.ops-dash-kpis {
  grid-area: kpis;
  min-height: 0;
}

.ops-dash-queue {
  grid-area: queue;
}

.ops-dash-enroll {
  grid-area: enroll;
  min-height: 0;
}

.ops-dash-right {
  grid-area: right;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1.05fr);
  grid-template-areas:
    "enrollments collections"
    "free free";
  gap: 10px;
  overflow: hidden;
}

.ops-dash-enrollments {
  grid-area: enrollments;
  min-height: 0;
}

.ops-dash-collections {
  grid-area: collections;
  min-height: 0;
}

.ops-dash-free {
  grid-area: free;
  min-height: 0;
}

.ops-hero {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 1fr);
  align-items: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(143, 155, 175, 0.14);
  border-radius: 18px;
  padding: 16px 20px;
  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);
  min-width: 0;
  min-height: 0;
}

.ops-hero-left {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.ops-hero-right {
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(245, 247, 252, 0.9);
  border: 1px solid rgba(143, 155, 175, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.ops-hero h1 {
  margin: 0;
  font-size: clamp(1.55rem, 2.2vw, 2rem);
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #1f2430;
}

.ops-reflect {
  margin: 0;
  color: #5a5568;
  font-size: clamp(0.95rem, 1.15vw, 1.08rem);
  line-height: 1.45;
  max-width: 38rem;
  font-style: italic;
}

.ops-briefing-label {
  display: block;
  margin-bottom: 6px;
  color: #6f7588;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ops-briefing {
  margin: 0;
  color: #3f4558;
  font-size: 0.95rem;
  line-height: 1.45;
}

.ops-loading,
.ops-error {
  flex: 1 1 auto;
  background: rgba(255, 255, 255, 0.76);
  border: 1px solid rgba(143, 155, 175, 0.15);
  border-radius: 16px;
  padding: 16px 18px;
  color: #5e6475;
  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);
}

.ops-error {
  color: #7a3b3b;
  border-color: rgba(200, 120, 120, 0.35);
}

.ops-kpi-shelf {
  background: rgba(255, 255, 255, 0.72);
  border: none;
  border-radius: 18px;
  padding: 4px;
  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.04);
  backdrop-filter: blur(12px);
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.ops-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 0;
  height: 100%;
  min-height: 0;
}

.ops-kpi {
  position: relative;
  background: transparent;
  border: none;
  border-radius: 10px;
  padding: 7px 10px 6px;
  box-shadow: none;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0;
  min-width: 0;
  min-height: 0;
  transition: background 0.15s ease;
}

.ops-kpi::before,
.ops-kpi::after {
  content: "";
  position: absolute;
  pointer-events: none;
  opacity: 0;
}

/* Faded partial dividers — internal only, soft ends */
.ops-kpi:not(:nth-child(4n))::after {
  top: 22%;
  bottom: 22%;
  right: 0;
  width: 1px;
  opacity: 1;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(143, 155, 175, 0.22) 25%,
    rgba(143, 155, 175, 0.22) 75%,
    transparent 100%
  );
}

.ops-kpi:nth-child(-n + 4)::before {
  left: 14%;
  right: 14%;
  bottom: 0;
  height: 1px;
  opacity: 1;
  background: linear-gradient(
    to right,
    transparent 0%,
    rgba(143, 155, 175, 0.22) 20%,
    rgba(143, 155, 175, 0.22) 80%,
    transparent 100%
  );
}

a.ops-kpi:hover {
  background: rgba(245, 247, 252, 0.9);
  text-decoration: none;
  color: inherit;
}

a.ops-kpi:hover .ops-kpi-rule {
  background: #8b82c9;
  width: 24px;
}

.ops-kpi--empty {
  pointer-events: none;
}

.ops-kpi-value {
  margin: 0 0 5px;
  font-size: clamp(0.95rem, 1.2vw, 1.15rem);
  color: #1f2430;
  letter-spacing: -0.035em;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.ops-kpi-rule {
  display: block;
  width: 18px;
  height: 1.5px;
  border-radius: 999px;
  background: rgba(143, 155, 175, 0.4);
  margin: 0 0 5px;
  transition: width 0.15s ease, background 0.15s ease;
}

.ops-kpi-label {
  color: #5e6475;
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: 0.005em;
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.ops-panel {
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(143, 155, 175, 0.13);
  border-radius: 16px;
  padding: 12px 13px;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);
  backdrop-filter: blur(10px);
}

.ops-panel--empty {
  background: rgba(245, 247, 252, 0.7);
  border-style: dashed;
  border-color: rgba(143, 155, 175, 0.28);
  box-shadow: none;
}

.ops-panel-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  flex: 0 0 auto;
}

.ops-panel-head h2 {
  margin: 0;
  font-size: 0.95rem;
  color: #1f2430;
  letter-spacing: -0.02em;
}

.ops-panel-head span {
  color: #6f7588;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;
}

.ops-muted {
  margin: 0;
  color: #8a849c;
  font-size: 0.8rem;
}

.ops-section-label {
  margin: 0 0 6px;
  color: #6f7588;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  flex: 0 0 auto;
}

.ops-queue {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.ops-queue-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid rgba(143, 155, 175, 0.14);
  border-radius: 12px;
  text-decoration: none;
  color: #2c3140;
  background: rgba(245, 247, 252, 0.95);
}

.ops-queue-item:hover {
  background: rgba(236, 240, 252, 0.98);
  text-decoration: none;
  color: #2c3140;
}

.ops-queue-item span {
  font-size: 0.82rem;
  font-weight: 600;
  min-width: 0;
}

.ops-queue-item strong {
  font-size: 0.95rem;
  font-variant-numeric: tabular-nums;
}

.ops-queue-empty {
  margin: auto 0;
  color: #5e6475;
  font-size: 0.88rem;
  line-height: 1.45;
}

.ops-enroll-stack {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
}

.ops-enroll-block {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.ops-enroll-block--pie {
  flex: 1 1 auto;
  gap: 16px;
  overflow: hidden;
}

.ops-enroll-hero {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.ops-enroll-hero-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
  min-width: 0;
  padding-top: 6px;
  align-self: stretch;
}

.ops-enroll-hero-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.7rem;
  min-width: 0;
}

.ops-enroll-hero-copy h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2430;
  letter-spacing: -0.025em;
  line-height: 1.15;
}

.ops-help-tip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.15rem;
  height: 1.15rem;
  margin: 0;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(143, 155, 175, 0.4);
  background: #f5f7fc;
  color: #5e6475;
  font-size: 0.68rem;
  font-weight: 800;
  font-style: italic;
  line-height: 1;
  cursor: help;
  flex-shrink: 0;
}

.ops-help-tip:hover,
.ops-help-tip:focus-visible {
  background: #ebeff8;
  color: #1f2430;
  border-color: rgba(106, 142, 200, 0.55);
  outline: none;
}

.ops-schedule-chips {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  width: min(100%, 420px);
}

.ops-schedule-chip {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(245, 247, 252, 0.95);
  border: 1px solid rgba(143, 155, 175, 0.16);
}


.ops-schedule-chip span {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7588;
}

.ops-schedule-chip strong {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1f2430;
  letter-spacing: -0.02em;
  line-height: 1.15;
}

.ops-schedule-chip em {
  font-style: normal;
  font-size: 0.68rem;
  font-weight: 600;
  color: #5e6475;
  line-height: 1.25;
}

.ops-enroll-bottom {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 0;
  padding-top: 8px;
  border-top: 1px solid rgba(143, 155, 175, 0.14);
  min-height: 0;
}

.ops-enroll-bottom .ops-enroll-block {
  min-width: 0;
}

.ops-enroll-bottom .ops-enroll-block:first-child {
  padding-right: 16px;
}

.ops-enroll-bottom .ops-enroll-block:last-child {
  padding-left: 16px;
  border-left: 1px solid rgba(143, 155, 175, 0.14);
}

.ops-teacher-pie-pair {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  flex: 0 0 auto;
  min-width: 0;
}

.ops-teacher-pie-viz {
  position: relative;
  flex: 0 0 auto;
  box-sizing: border-box;
  --pie-size: 148px;
  width: var(--pie-size);
  height: var(--pie-size);
  aspect-ratio: 1 / 1;
}

.ops-teacher-pie-svg {
  display: block;
  width: 100%;
  height: 100%;
}

.ops-teacher-pie-center {
  position: absolute;
  inset: 23%;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.97);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  pointer-events: none;
}

.ops-teacher-pie-center strong {
  color: #1f2430;
  font-size: clamp(1.05rem, 1.8vh, 1.35rem);
  letter-spacing: -0.03em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.ops-teacher-pie-center span {
  color: #6f7588;
  font-size: clamp(0.58rem, 1vh, 0.7rem);
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.ops-teacher-pie-key {
  width: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(0, auto);
  align-content: start;
  column-gap: 28px;
  row-gap: 22px;
  padding-top: 4px;
}

.ops-teacher-pie-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  column-gap: 10px;
  row-gap: 4px;
  align-items: center;
  min-width: 0;
  border-radius: 8px;
  cursor: pointer;
}

.ops-teacher-pie-row.is-active .ops-teacher-pie-name,
.ops-teacher-pie-row.is-active .ops-teacher-pie-metrics strong {
  color: #1f2430;
}

.ops-teacher-arc {
  cursor: pointer;
  transition: stroke-width 0.16s ease, opacity 0.16s ease;
}

.ops-teacher-pie-viz.is-linked .ops-teacher-arc.is-active,
.ops-mix-pie-viz.is-linked .ops-teacher-arc.is-active {
  stroke-width: 26;
  filter: drop-shadow(0 1px 2px rgba(31, 36, 48, 0.28));
}

.ops-teacher-pie-id {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.ops-teacher-pie-row.is-idle .ops-teacher-pie-name,
.ops-teacher-pie-row.is-idle .ops-teacher-pie-metrics strong {
  color: #8a849c;
  font-weight: 600;
}

.ops-teacher-pie-swatch {
  width: 9px;
  height: 9px;
  border-radius: 2px;
  flex: 0 0 auto;
}

.ops-teacher-pie-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: #3f4558;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.ops-teacher-pie-metrics {
  grid-row: 1 / span 2;
  grid-column: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  white-space: nowrap;
}

.ops-teacher-pie-metrics strong {
  font-size: 0.8rem;
  font-weight: 700;
  color: #1f2430;
  font-variant-numeric: tabular-nums;
  line-height: 1.15;
}

.ops-teacher-pie-metrics span {
  font-size: 0.72rem;
  font-weight: 600;
  color: #6f7588;
  line-height: 1.15;
}

.ops-teacher-pie-bar {
  grid-column: 1;
  grid-row: 2;
  height: 5px;
  border-radius: 999px;
  background: rgba(143, 155, 175, 0.14);
  overflow: hidden;
}

.ops-teacher-pie-bar > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  min-width: 0;
}

.ops-top-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ops-top-list-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
}

.ops-top-list-name {
  font-size: 0.76rem;
  font-weight: 600;
  color: #3f4558;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.ops-top-list-count {
  font-size: 0.76rem;
  font-weight: 700;
  color: #1f2430;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.ops-chart-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ops-bars {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: flex-end;
  gap: 2px;
  padding: 4px 2px 0;
}

/* Chart tip — same visual language as shared AppTooltip. */
.ops-bar-tip {
  position: absolute;
  top: 2px;
  z-index: 3;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 132px;
  padding: 7px 9px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(143, 155, 175, 0.22);
  box-shadow: 0 8px 18px rgba(52, 62, 94, 0.12);
  pointer-events: none;
}

.ops-bar-tip--start {
  left: 0 !important;
  transform: none;
}

.ops-bar-tip--end {
  left: auto !important;
  right: 0;
  transform: none;
}

.ops-bar-tip-date {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7588;
}

.ops-bar-tip-line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #5e6475;
}

.ops-bar-tip-line strong {
  color: #1f2430;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.ops-bar-col.is-hot .ops-bar {
  filter: brightness(1.08);
}

.ops-bars.is-empty {
  opacity: 0.55;
}

.ops-bar-col {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.ops-bar {
  width: 100%;
  max-width: 26px;
  border-radius: 4px 4px 0 0;
  min-height: 2px;
}

.ops-bar--default,
.ops-bar--enrollments {
  background: #6a8ec8;
}

.ops-bar--cash {
  background: #5bb894;
}

.ops-bar.is-flat {
  opacity: 0.4;
}

.ops-bars .ops-bar {
  max-width: 12px;
}

.ops-bars-axis {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 14px;
  padding: 0 2px;
}

.ops-bars-axis-label {
  font-size: 0.58rem;
  font-weight: 600;
  color: #6f7588;
  line-height: 1;
  white-space: nowrap;
}

.ops-bars-axis-label--start {
  text-align: left;
}

.ops-bars-axis-label--center {
  text-align: center;
}

.ops-bars-axis-label--end {
  text-align: right;
}

.ops-line-svg {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  display: block;
}

.ops-line-baseline {
  stroke: rgba(143, 155, 175, 0.22);
  stroke-width: 1;
  vector-effect: non-scaling-stroke;
}

.ops-line-area {
  fill: rgba(106, 142, 200, 0.14);
}

.ops-line-path {
  stroke: #6a8ec8;
  stroke-width: 2.25;
  stroke-linejoin: round;
  stroke-linecap: round;
  vector-effect: non-scaling-stroke;
}

.ops-line-dot {
  fill: #6a8ec8;
  stroke: #fff;
  stroke-width: 1.25;
  vector-effect: non-scaling-stroke;
}

.ops-line-xtick {
  fill: #6f7588;
  font-size: 8px;
  font-weight: 600;
}

.ops-chart-foot {
  flex: 0 0 auto;
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin: 0;
  padding-top: 2px;
  border-top: 1px solid rgba(143, 155, 175, 0.12);
}

.ops-chart-foot strong {
  font-size: 0.95rem;
  color: #1f2430;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}

.ops-chart-foot span {
  font-size: 0.72rem;
  font-weight: 600;
  color: #6f7588;
  text-transform: none;
  letter-spacing: 0;
}

.ops-chart-empty {
  flex: 0 0 auto;
  margin: 0;
  padding-top: 2px;
  border-top: 1px solid rgba(143, 155, 175, 0.12);
  font-size: 0.74rem;
  font-weight: 600;
  color: #8a849c;
}

.ops-free-grid {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  overflow: hidden;
}

.ops-free-col {
  min-width: 0;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  border: 1px solid rgba(143, 155, 175, 0.12);
  border-radius: 12px;
  background: rgba(245, 247, 252, 0.95);
}

.ops-library-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
}

.ops-cov-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
}

.ops-library-assets {
  flex: 0 0 auto;
}

.ops-library-mix {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ops-asset-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));
  gap: 6px;
}

.ops-asset-chip {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(143, 155, 175, 0.12);
  text-decoration: none;
  color: inherit;
  transition: background 0.15s ease, border-color 0.15s ease;
}

a.ops-asset-chip:hover {
  background: #fff;
  border-color: rgba(120, 130, 170, 0.28);
  text-decoration: none;
  color: inherit;
}

.ops-asset-chip strong {
  font-size: 0.95rem;
  color: #1f2430;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.ops-asset-chip span {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6f7588;
}

.ops-mix-pie {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}

.ops-mix-pie-viz {
  position: relative;
  flex: 0 0 120px;
  width: 120px;
  height: 120px;
  align-self: center;
}

.ops-mix-pie-svg {
  display: block;
  width: 120px;
  height: 120px;
  overflow: visible;
}

.ops-mix-pie-center {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 0 0 1px rgba(143, 155, 175, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  pointer-events: none;
}

.ops-mix-pie-center strong {
  color: #1f2430;
  font-size: clamp(0.72rem, 1.3vh, 0.95rem);
  letter-spacing: -0.03em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.ops-mix-pie-center span {
  color: #6f7588;
  font-size: clamp(0.48rem, 0.8vh, 0.58rem);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ops-mix-pie-key {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ops-mix-pie-row {
  display: grid;
  grid-template-columns: 8px minmax(0, 1fr) auto;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  cursor: pointer;
}

.ops-mix-pie-row.is-active .ops-mix-pie-label,
.ops-mix-pie-row.is-active .ops-mix-pie-count {
  color: #1f2430;
}

.ops-mix-pie-swatch {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.ops-mix-pie-label {
  font-size: 0.68rem;
  font-weight: 600;
  color: #3f4558;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.ops-mix-pie-count {
  font-size: 0.68rem;
  font-weight: 700;
  color: #1f2430;
  font-variant-numeric: tabular-nums;
}

.ops-cov-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-decoration: none;
  color: inherit;
}

a.ops-cov-row:hover {
  text-decoration: none;
  color: inherit;
}

.ops-cov-meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.78rem;
}

.ops-cov-meta span {
  color: #3f4558;
  font-weight: 600;
}

.ops-cov-meta strong {
  color: #1f2430;
  font-variant-numeric: tabular-nums;
  font-weight: 650;
}

.ops-cov-missing {
  font-style: normal;
  color: #9a6b5c;
  font-weight: 550;
}

.ops-cov-track {
  height: 6px;
  border-radius: 999px;
  background: rgba(226, 230, 242, 0.9);
  overflow: hidden;
}

.ops-cov-fill {
  height: 100%;
  border-radius: 999px;
  min-width: 0;
}

.ops-cov-fill--library {
  background: linear-gradient(90deg, #b8aef0, #9eb8f0);
}

.ops-cov-fill--explore {
  background: linear-gradient(90deg, #8ec5b0, #6fbf9d);
}

.ops-engage-summary {
  margin: 0 0 20px;
  font-size: 0.78rem;
  color: #5e6475;
  line-height: 1.35;
}

.ops-engage-summary strong {
  color: #1f2430;
  font-variant-numeric: tabular-nums;
}

.ops-engage-lists {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
  overflow: auto;
}

.ops-engage-sub {
  margin: 0 0 6px;
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6f7588;
}

.ops-rank-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ops-rank-list li {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px;
  align-items: center;
  font-size: 0.74rem;
}

.ops-rank-list span {
  color: #3f4558;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.ops-rank-list strong {
  color: #1f2430;
  font-variant-numeric: tabular-nums;
  font-weight: 650;
  white-space: nowrap;
}

@media (max-width: 1280px) {
  .ops-dash {
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr);
    grid-template-rows: auto auto minmax(0, 1fr);
    grid-template-areas:
      "hero queue"
      "kpis queue"
      "enroll right";
  }

  .ops-dash-right {
    grid-template-rows: minmax(140px, 0.9fr) minmax(0, 1.1fr);
  }
}

@media (max-width: 1100px) {
  .ops-layout {
    grid-template-columns: 1fr;
    height: 100%;
    overflow: hidden;
  }

  .ops-sidebar {
    display: none;
  }

  .ops-mobile-nav {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 0 0 auto;
  }

  .ops-mobile-nav .ops-module-nav {
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid rgba(143, 155, 175, 0.16);
    border-radius: 16px;
    padding: 8px 10px;
    box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);
  }

  .ops-mobile-nav .ops-sidebar-logout {
    width: 100% !important;
  }

  .ops-mobile-nav .ops-module-nav-list {
    flex-direction: row;
    overflow-x: auto;
    gap: 4px;
  }

  .ops-mobile-nav .ops-module-link {
    flex-direction: column;
    align-items: center;
    min-width: 70px;
    padding: 8px 6px;
    text-align: center;
    gap: 5px;
  }

  .ops-mobile-nav .ops-module-name {
    font-size: 0.64rem;
    line-height: 1.15;
  }

  .ops-main {
    height: 100%;
    overflow: hidden;
  }
}

@media (max-width: 900px) {
  .ops-hero {
    grid-template-columns: 1fr;
  }

  .ops-kpi-shelf {
    padding: 2px;
  }

  .ops-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(4, auto);
  }

  .ops-kpi {
    padding: 8px 10px;
  }

  .ops-kpi::before,
  .ops-kpi::after,
  .ops-kpi:nth-child(-n + 4)::before,
  .ops-kpi:not(:nth-child(4n))::after {
    opacity: 0;
  }

  .ops-kpi:nth-child(odd)::after {
    top: 22%;
    bottom: 22%;
    right: 0;
    width: 1px;
    opacity: 1;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(143, 155, 175, 0.22) 25%,
      rgba(143, 155, 175, 0.22) 75%,
      transparent 100%
    );
  }

  .ops-kpi:not(:nth-last-child(-n + 2))::before {
    left: 14%;
    right: 14%;
    bottom: 0;
    height: 1px;
    opacity: 1;
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(143, 155, 175, 0.22) 20%,
      rgba(143, 155, 175, 0.22) 80%,
      transparent 100%
    );
  }

  .ops-dash {
    overflow: auto;
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-template-areas:
      "hero"
      "kpis"
      "queue"
      "enroll"
      "right";
  }

  .ops-dash-right {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-template-areas:
      "enrollments"
      "collections"
      "free";
    height: auto;
    overflow: visible;
  }

  .ops-free-grid,
  .ops-engage-lists {
    grid-template-columns: 1fr;
  }

  .ops-panel {
    overflow: visible;
    height: auto;
  }

  .ops-enroll-hero {
    align-items: flex-start;
  }

  .ops-enroll-hero-copy {
    padding-top: 0;
    align-self: flex-start;
  }

  .ops-teacher-pie-pair {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }

  .ops-teacher-pie-viz {
    --pie-size: min(140px, 40vw);
  }

  .ops-teacher-pie-key {
    grid-template-columns: 1fr;
  }

  .ops-enroll-bottom {
    grid-template-columns: 1fr;
  }

  .ops-enroll-bottom .ops-enroll-block:first-child {
    padding-right: 0;
  }

  .ops-enroll-bottom .ops-enroll-block:last-child {
    padding-left: 0;
    border-left: none;
    padding-top: 8px;
    border-top: 1px solid rgba(143, 155, 175, 0.14);
  }
}

@media (max-width: 720px) {
  .admin-dashboard-shell {
    position: relative;
    height: auto;
    overflow: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qEAAqE;EACrE,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,gDAAgD;EAChD,4CAA4C;EAC5C;;;+BAG6B;EAC7B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,oDAAoD;EACpD;;eAEa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6CAA6C;EAC7C,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,UAAU;EACV,UAAU;EACV;;;;;;GAMC;AACH;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV;;;;;;GAMC;AACH;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;;EAEE,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,qBAAqB;EACrB,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,uDAAuD;IACvD,4CAA4C;IAC5C;;;oBAGgB;EAClB;;EAEA;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,iBAAiB;IACjB,6CAA6C;EAC/C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gDAAgD;IAChD,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,UAAU;IACV,UAAU;IACV;;;;;;KAMC;EACH;;EAEA;IACE,SAAS;IACT,UAAU;IACV,SAAS;IACT,WAAW;IACX,UAAU;IACV;;;;;;KAMC;EACH;;EAEA;IACE,cAAc;IACd,0BAA0B;IAC1B,wBAAwB;IACxB;;;;;aAKS;EACX;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB;;;YAGQ;IACR,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":[".ops-layout {\n  display: grid;\n  grid-template-columns: var(--ops-sidebar-width, 280px) minmax(0, 1fr);\n  gap: 14px;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.ops-sidebar {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.82);\n  border: 1px solid rgba(143, 155, 175, 0.16);\n  border-radius: 22px;\n  padding: 16px 10px;\n  box-shadow: 0 10px 24px rgba(52, 62, 94, 0.06);\n  backdrop-filter: blur(12px);\n}\n\n.ops-sidebar-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.ops-sidebar-footer {\n  flex: 0 0 auto;\n  padding-top: 12px;\n  margin-top: 8px;\n  border-top: 1px solid rgba(143, 155, 175, 0.14);\n}\n\n.ops-sidebar-logout {\n  width: 100% !important;\n  justify-content: center !important;\n}\n\n.ops-mobile-nav {\n  display: none;\n}\n\n.ops-module-nav-label {\n  padding: 2px 12px 10px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #5e6475;\n}\n\n.ops-module-nav-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ops-module-link {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 12px;\n  text-decoration: none;\n  color: #2c3140;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.ops-module-link:hover {\n  background: rgba(236, 240, 252, 0.98);\n  box-shadow: inset 3px 0 0 #b8aef0;\n  text-decoration: none;\n  color: #2c3140;\n}\n\n.ops-module-dot {\n  width: 30px;\n  height: 30px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #fff;\n  font-size: 0.78rem;\n}\n\n.ops-module-name {\n  font-size: 0.86rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: normal;\n  overflow: visible;\n  word-break: break-word;\n  padding-top: 4px;\n}\n\n.ops-main {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\n.ops-dash {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-template-rows: auto auto minmax(0, 1fr);\n  grid-template-areas:\n    \"hero hero hero queue\"\n    \"kpis kpis kpis queue\"\n    \"enroll enroll right right\";\n  gap: 10px;\n  overflow: hidden;\n}\n\n.ops-dash-hero {\n  grid-area: hero;\n}\n\n.ops-dash-kpis {\n  grid-area: kpis;\n  min-height: 0;\n}\n\n.ops-dash-queue {\n  grid-area: queue;\n}\n\n.ops-dash-enroll {\n  grid-area: enroll;\n  min-height: 0;\n}\n\n.ops-dash-right {\n  grid-area: right;\n  min-width: 0;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: minmax(0, 1fr) minmax(0, 1.05fr);\n  grid-template-areas:\n    \"enrollments collections\"\n    \"free free\";\n  gap: 10px;\n  overflow: hidden;\n}\n\n.ops-dash-enrollments {\n  grid-area: enrollments;\n  min-height: 0;\n}\n\n.ops-dash-collections {\n  grid-area: collections;\n  min-height: 0;\n}\n\n.ops-dash-free {\n  grid-area: free;\n  min-height: 0;\n}\n\n.ops-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 1fr);\n  align-items: center;\n  gap: 20px;\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid rgba(143, 155, 175, 0.14);\n  border-radius: 18px;\n  padding: 16px 20px;\n  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);\n  min-width: 0;\n  min-height: 0;\n}\n\n.ops-hero-left {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n}\n\n.ops-hero-right {\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: rgba(245, 247, 252, 0.9);\n  border: 1px solid rgba(143, 155, 175, 0.12);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n\n.ops-hero h1 {\n  margin: 0;\n  font-size: clamp(1.55rem, 2.2vw, 2rem);\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n  color: #1f2430;\n}\n\n.ops-reflect {\n  margin: 0;\n  color: #5a5568;\n  font-size: clamp(0.95rem, 1.15vw, 1.08rem);\n  line-height: 1.45;\n  max-width: 38rem;\n  font-style: italic;\n}\n\n.ops-briefing-label {\n  display: block;\n  margin-bottom: 6px;\n  color: #6f7588;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.ops-briefing {\n  margin: 0;\n  color: #3f4558;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.ops-loading,\n.ops-error {\n  flex: 1 1 auto;\n  background: rgba(255, 255, 255, 0.76);\n  border: 1px solid rgba(143, 155, 175, 0.15);\n  border-radius: 16px;\n  padding: 16px 18px;\n  color: #5e6475;\n  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);\n}\n\n.ops-error {\n  color: #7a3b3b;\n  border-color: rgba(200, 120, 120, 0.35);\n}\n\n.ops-kpi-shelf {\n  background: rgba(255, 255, 255, 0.72);\n  border: none;\n  border-radius: 18px;\n  padding: 4px;\n  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.04);\n  backdrop-filter: blur(12px);\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.ops-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n  gap: 0;\n  height: 100%;\n  min-height: 0;\n}\n\n.ops-kpi {\n  position: relative;\n  background: transparent;\n  border: none;\n  border-radius: 10px;\n  padding: 7px 10px 6px;\n  box-shadow: none;\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 0;\n  min-width: 0;\n  min-height: 0;\n  transition: background 0.15s ease;\n}\n\n.ops-kpi::before,\n.ops-kpi::after {\n  content: \"\";\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n}\n\n/* Faded partial dividers — internal only, soft ends */\n.ops-kpi:not(:nth-child(4n))::after {\n  top: 22%;\n  bottom: 22%;\n  right: 0;\n  width: 1px;\n  opacity: 1;\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(143, 155, 175, 0.22) 25%,\n    rgba(143, 155, 175, 0.22) 75%,\n    transparent 100%\n  );\n}\n\n.ops-kpi:nth-child(-n + 4)::before {\n  left: 14%;\n  right: 14%;\n  bottom: 0;\n  height: 1px;\n  opacity: 1;\n  background: linear-gradient(\n    to right,\n    transparent 0%,\n    rgba(143, 155, 175, 0.22) 20%,\n    rgba(143, 155, 175, 0.22) 80%,\n    transparent 100%\n  );\n}\n\na.ops-kpi:hover {\n  background: rgba(245, 247, 252, 0.9);\n  text-decoration: none;\n  color: inherit;\n}\n\na.ops-kpi:hover .ops-kpi-rule {\n  background: #8b82c9;\n  width: 24px;\n}\n\n.ops-kpi--empty {\n  pointer-events: none;\n}\n\n.ops-kpi-value {\n  margin: 0 0 5px;\n  font-size: clamp(0.95rem, 1.2vw, 1.15rem);\n  color: #1f2430;\n  letter-spacing: -0.035em;\n  font-weight: 700;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-kpi-rule {\n  display: block;\n  width: 18px;\n  height: 1.5px;\n  border-radius: 999px;\n  background: rgba(143, 155, 175, 0.4);\n  margin: 0 0 5px;\n  transition: width 0.15s ease, background 0.15s ease;\n}\n\n.ops-kpi-label {\n  color: #5e6475;\n  font-size: 0.72rem;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: 0.005em;\n  max-width: 100%;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.ops-panel {\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(143, 155, 175, 0.13);\n  border-radius: 16px;\n  padding: 12px 13px;\n  min-width: 0;\n  min-height: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);\n  backdrop-filter: blur(10px);\n}\n\n.ops-panel--empty {\n  background: rgba(245, 247, 252, 0.7);\n  border-style: dashed;\n  border-color: rgba(143, 155, 175, 0.28);\n  box-shadow: none;\n}\n\n.ops-panel-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n  flex: 0 0 auto;\n}\n\n.ops-panel-head h2 {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #1f2430;\n  letter-spacing: -0.02em;\n}\n\n.ops-panel-head span {\n  color: #6f7588;\n  font-size: 0.7rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.ops-muted {\n  margin: 0;\n  color: #8a849c;\n  font-size: 0.8rem;\n}\n\n.ops-section-label {\n  margin: 0 0 6px;\n  color: #6f7588;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  flex: 0 0 auto;\n}\n\n.ops-queue {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.ops-queue-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 10px;\n  border: 1px solid rgba(143, 155, 175, 0.14);\n  border-radius: 12px;\n  text-decoration: none;\n  color: #2c3140;\n  background: rgba(245, 247, 252, 0.95);\n}\n\n.ops-queue-item:hover {\n  background: rgba(236, 240, 252, 0.98);\n  text-decoration: none;\n  color: #2c3140;\n}\n\n.ops-queue-item span {\n  font-size: 0.82rem;\n  font-weight: 600;\n  min-width: 0;\n}\n\n.ops-queue-item strong {\n  font-size: 0.95rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-queue-empty {\n  margin: auto 0;\n  color: #5e6475;\n  font-size: 0.88rem;\n  line-height: 1.45;\n}\n\n.ops-enroll-stack {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.ops-enroll-block {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n}\n\n.ops-enroll-block--pie {\n  flex: 1 1 auto;\n  gap: 16px;\n  overflow: hidden;\n}\n\n.ops-enroll-hero {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.ops-enroll-hero-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n  min-width: 0;\n  padding-top: 6px;\n  align-self: stretch;\n}\n\n.ops-enroll-hero-title {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.7rem;\n  min-width: 0;\n}\n\n.ops-enroll-hero-copy h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1f2430;\n  letter-spacing: -0.025em;\n  line-height: 1.15;\n}\n\n.ops-help-tip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.15rem;\n  height: 1.15rem;\n  margin: 0;\n  padding: 0;\n  border-radius: 999px;\n  border: 1px solid rgba(143, 155, 175, 0.4);\n  background: #f5f7fc;\n  color: #5e6475;\n  font-size: 0.68rem;\n  font-weight: 800;\n  font-style: italic;\n  line-height: 1;\n  cursor: help;\n  flex-shrink: 0;\n}\n\n.ops-help-tip:hover,\n.ops-help-tip:focus-visible {\n  background: #ebeff8;\n  color: #1f2430;\n  border-color: rgba(106, 142, 200, 0.55);\n  outline: none;\n}\n\n.ops-schedule-chips {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  width: min(100%, 420px);\n}\n\n.ops-schedule-chip {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-width: 0;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: rgba(245, 247, 252, 0.95);\n  border: 1px solid rgba(143, 155, 175, 0.16);\n}\n\n\n.ops-schedule-chip span {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #6f7588;\n}\n\n.ops-schedule-chip strong {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #1f2430;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n}\n\n.ops-schedule-chip em {\n  font-style: normal;\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #5e6475;\n  line-height: 1.25;\n}\n\n.ops-enroll-bottom {\n  flex: 0 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 0;\n  padding-top: 8px;\n  border-top: 1px solid rgba(143, 155, 175, 0.14);\n  min-height: 0;\n}\n\n.ops-enroll-bottom .ops-enroll-block {\n  min-width: 0;\n}\n\n.ops-enroll-bottom .ops-enroll-block:first-child {\n  padding-right: 16px;\n}\n\n.ops-enroll-bottom .ops-enroll-block:last-child {\n  padding-left: 16px;\n  border-left: 1px solid rgba(143, 155, 175, 0.14);\n}\n\n.ops-teacher-pie-pair {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.ops-teacher-pie-viz {\n  position: relative;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  --pie-size: 148px;\n  width: var(--pie-size);\n  height: var(--pie-size);\n  aspect-ratio: 1 / 1;\n}\n\n.ops-teacher-pie-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.ops-teacher-pie-center {\n  position: absolute;\n  inset: 23%;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.97);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  pointer-events: none;\n}\n\n.ops-teacher-pie-center strong {\n  color: #1f2430;\n  font-size: clamp(1.05rem, 1.8vh, 1.35rem);\n  letter-spacing: -0.03em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-teacher-pie-center span {\n  color: #6f7588;\n  font-size: clamp(0.58rem, 1vh, 0.7rem);\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.ops-teacher-pie-key {\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: minmax(0, auto);\n  align-content: start;\n  column-gap: 28px;\n  row-gap: 22px;\n  padding-top: 4px;\n}\n\n.ops-teacher-pie-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-rows: auto auto;\n  column-gap: 10px;\n  row-gap: 4px;\n  align-items: center;\n  min-width: 0;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.ops-teacher-pie-row.is-active .ops-teacher-pie-name,\n.ops-teacher-pie-row.is-active .ops-teacher-pie-metrics strong {\n  color: #1f2430;\n}\n\n.ops-teacher-arc {\n  cursor: pointer;\n  transition: stroke-width 0.16s ease, opacity 0.16s ease;\n}\n\n.ops-teacher-pie-viz.is-linked .ops-teacher-arc.is-active,\n.ops-mix-pie-viz.is-linked .ops-teacher-arc.is-active {\n  stroke-width: 26;\n  filter: drop-shadow(0 1px 2px rgba(31, 36, 48, 0.28));\n}\n\n.ops-teacher-pie-id {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.ops-teacher-pie-row.is-idle .ops-teacher-pie-name,\n.ops-teacher-pie-row.is-idle .ops-teacher-pie-metrics strong {\n  color: #8a849c;\n  font-weight: 600;\n}\n\n.ops-teacher-pie-swatch {\n  width: 9px;\n  height: 9px;\n  border-radius: 2px;\n  flex: 0 0 auto;\n}\n\n.ops-teacher-pie-name {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #3f4558;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.ops-teacher-pie-metrics {\n  grid-row: 1 / span 2;\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n  white-space: nowrap;\n}\n\n.ops-teacher-pie-metrics strong {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.15;\n}\n\n.ops-teacher-pie-metrics span {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #6f7588;\n  line-height: 1.15;\n}\n\n.ops-teacher-pie-bar {\n  grid-column: 1;\n  grid-row: 2;\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(143, 155, 175, 0.14);\n  overflow: hidden;\n}\n\n.ops-teacher-pie-bar > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  min-width: 0;\n}\n\n.ops-top-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ops-top-list-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.ops-top-list-name {\n  font-size: 0.76rem;\n  font-weight: 600;\n  color: #3f4558;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.ops-top-list-count {\n  font-size: 0.76rem;\n  font-weight: 700;\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.ops-chart-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ops-bars {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 2px;\n  padding: 4px 2px 0;\n}\n\n/* Chart tip — same visual language as shared AppTooltip. */\n.ops-bar-tip {\n  position: absolute;\n  top: 2px;\n  z-index: 3;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 132px;\n  padding: 7px 9px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.97);\n  border: 1px solid rgba(143, 155, 175, 0.22);\n  box-shadow: 0 8px 18px rgba(52, 62, 94, 0.12);\n  pointer-events: none;\n}\n\n.ops-bar-tip--start {\n  left: 0 !important;\n  transform: none;\n}\n\n.ops-bar-tip--end {\n  left: auto !important;\n  right: 0;\n  transform: none;\n}\n\n.ops-bar-tip-date {\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #6f7588;\n}\n\n.ops-bar-tip-line {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #5e6475;\n}\n\n.ops-bar-tip-line strong {\n  color: #1f2430;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-bar-col.is-hot .ops-bar {\n  filter: brightness(1.08);\n}\n\n.ops-bars.is-empty {\n  opacity: 0.55;\n}\n\n.ops-bar-col {\n  flex: 1 1 0;\n  min-width: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.ops-bar {\n  width: 100%;\n  max-width: 26px;\n  border-radius: 4px 4px 0 0;\n  min-height: 2px;\n}\n\n.ops-bar--default,\n.ops-bar--enrollments {\n  background: #6a8ec8;\n}\n\n.ops-bar--cash {\n  background: #5bb894;\n}\n\n.ops-bar.is-flat {\n  opacity: 0.4;\n}\n\n.ops-bars .ops-bar {\n  max-width: 12px;\n}\n\n.ops-bars-axis {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 14px;\n  padding: 0 2px;\n}\n\n.ops-bars-axis-label {\n  font-size: 0.58rem;\n  font-weight: 600;\n  color: #6f7588;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.ops-bars-axis-label--start {\n  text-align: left;\n}\n\n.ops-bars-axis-label--center {\n  text-align: center;\n}\n\n.ops-bars-axis-label--end {\n  text-align: right;\n}\n\n.ops-line-svg {\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  display: block;\n}\n\n.ops-line-baseline {\n  stroke: rgba(143, 155, 175, 0.22);\n  stroke-width: 1;\n  vector-effect: non-scaling-stroke;\n}\n\n.ops-line-area {\n  fill: rgba(106, 142, 200, 0.14);\n}\n\n.ops-line-path {\n  stroke: #6a8ec8;\n  stroke-width: 2.25;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  vector-effect: non-scaling-stroke;\n}\n\n.ops-line-dot {\n  fill: #6a8ec8;\n  stroke: #fff;\n  stroke-width: 1.25;\n  vector-effect: non-scaling-stroke;\n}\n\n.ops-line-xtick {\n  fill: #6f7588;\n  font-size: 8px;\n  font-weight: 600;\n}\n\n.ops-chart-foot {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin: 0;\n  padding-top: 2px;\n  border-top: 1px solid rgba(143, 155, 175, 0.12);\n}\n\n.ops-chart-foot strong {\n  font-size: 0.95rem;\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n}\n\n.ops-chart-foot span {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #6f7588;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.ops-chart-empty {\n  flex: 0 0 auto;\n  margin: 0;\n  padding-top: 2px;\n  border-top: 1px solid rgba(143, 155, 175, 0.12);\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: #8a849c;\n}\n\n.ops-free-grid {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  overflow: hidden;\n}\n\n.ops-free-col {\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px;\n  border: 1px solid rgba(143, 155, 175, 0.12);\n  border-radius: 12px;\n  background: rgba(245, 247, 252, 0.95);\n}\n\n.ops-library-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow: auto;\n}\n\n.ops-cov-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.ops-library-assets {\n  flex: 0 0 auto;\n}\n\n.ops-library-mix {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ops-asset-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));\n  gap: 6px;\n}\n\n.ops-asset-chip {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 8px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(143, 155, 175, 0.12);\n  text-decoration: none;\n  color: inherit;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\na.ops-asset-chip:hover {\n  background: #fff;\n  border-color: rgba(120, 130, 170, 0.28);\n  text-decoration: none;\n  color: inherit;\n}\n\n.ops-asset-chip strong {\n  font-size: 0.95rem;\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.ops-asset-chip span {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #6f7588;\n}\n\n.ops-mix-pie {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.ops-mix-pie-viz {\n  position: relative;\n  flex: 0 0 120px;\n  width: 120px;\n  height: 120px;\n  align-self: center;\n}\n\n.ops-mix-pie-svg {\n  display: block;\n  width: 120px;\n  height: 120px;\n  overflow: visible;\n}\n\n.ops-mix-pie-center {\n  position: absolute;\n  inset: 0;\n  margin: auto;\n  width: 58px;\n  height: 58px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 0 0 1px rgba(143, 155, 175, 0.08);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1px;\n  pointer-events: none;\n}\n\n.ops-mix-pie-center strong {\n  color: #1f2430;\n  font-size: clamp(0.72rem, 1.3vh, 0.95rem);\n  letter-spacing: -0.03em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-mix-pie-center span {\n  color: #6f7588;\n  font-size: clamp(0.48rem, 0.8vh, 0.58rem);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ops-mix-pie-key {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ops-mix-pie-row {\n  display: grid;\n  grid-template-columns: 8px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 6px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.ops-mix-pie-row.is-active .ops-mix-pie-label,\n.ops-mix-pie-row.is-active .ops-mix-pie-count {\n  color: #1f2430;\n}\n\n.ops-mix-pie-swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n}\n\n.ops-mix-pie-label {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #3f4558;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.ops-mix-pie-count {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-cov-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-decoration: none;\n  color: inherit;\n}\n\na.ops-cov-row:hover {\n  text-decoration: none;\n  color: inherit;\n}\n\n.ops-cov-meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.78rem;\n}\n\n.ops-cov-meta span {\n  color: #3f4558;\n  font-weight: 600;\n}\n\n.ops-cov-meta strong {\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n  font-weight: 650;\n}\n\n.ops-cov-missing {\n  font-style: normal;\n  color: #9a6b5c;\n  font-weight: 550;\n}\n\n.ops-cov-track {\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(226, 230, 242, 0.9);\n  overflow: hidden;\n}\n\n.ops-cov-fill {\n  height: 100%;\n  border-radius: 999px;\n  min-width: 0;\n}\n\n.ops-cov-fill--library {\n  background: linear-gradient(90deg, #b8aef0, #9eb8f0);\n}\n\n.ops-cov-fill--explore {\n  background: linear-gradient(90deg, #8ec5b0, #6fbf9d);\n}\n\n.ops-engage-summary {\n  margin: 0 0 20px;\n  font-size: 0.78rem;\n  color: #5e6475;\n  line-height: 1.35;\n}\n\n.ops-engage-summary strong {\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n}\n\n.ops-engage-lists {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  overflow: auto;\n}\n\n.ops-engage-sub {\n  margin: 0 0 6px;\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #6f7588;\n}\n\n.ops-rank-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ops-rank-list li {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 6px;\n  align-items: center;\n  font-size: 0.74rem;\n}\n\n.ops-rank-list span {\n  color: #3f4558;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.ops-rank-list strong {\n  color: #1f2430;\n  font-variant-numeric: tabular-nums;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n@media (max-width: 1280px) {\n  .ops-dash {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr);\n    grid-template-rows: auto auto minmax(0, 1fr);\n    grid-template-areas:\n      \"hero queue\"\n      \"kpis queue\"\n      \"enroll right\";\n  }\n\n  .ops-dash-right {\n    grid-template-rows: minmax(140px, 0.9fr) minmax(0, 1.1fr);\n  }\n}\n\n@media (max-width: 1100px) {\n  .ops-layout {\n    grid-template-columns: 1fr;\n    height: 100%;\n    overflow: hidden;\n  }\n\n  .ops-sidebar {\n    display: none;\n  }\n\n  .ops-mobile-nav {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex: 0 0 auto;\n  }\n\n  .ops-mobile-nav .ops-module-nav {\n    background: rgba(255, 255, 255, 0.78);\n    border: 1px solid rgba(143, 155, 175, 0.16);\n    border-radius: 16px;\n    padding: 8px 10px;\n    box-shadow: 0 8px 20px rgba(52, 62, 94, 0.05);\n  }\n\n  .ops-mobile-nav .ops-sidebar-logout {\n    width: 100% !important;\n  }\n\n  .ops-mobile-nav .ops-module-nav-list {\n    flex-direction: row;\n    overflow-x: auto;\n    gap: 4px;\n  }\n\n  .ops-mobile-nav .ops-module-link {\n    flex-direction: column;\n    align-items: center;\n    min-width: 70px;\n    padding: 8px 6px;\n    text-align: center;\n    gap: 5px;\n  }\n\n  .ops-mobile-nav .ops-module-name {\n    font-size: 0.64rem;\n    line-height: 1.15;\n  }\n\n  .ops-main {\n    height: 100%;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 900px) {\n  .ops-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .ops-kpi-shelf {\n    padding: 2px;\n  }\n\n  .ops-kpi-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    grid-template-rows: repeat(4, auto);\n  }\n\n  .ops-kpi {\n    padding: 8px 10px;\n  }\n\n  .ops-kpi::before,\n  .ops-kpi::after,\n  .ops-kpi:nth-child(-n + 4)::before,\n  .ops-kpi:not(:nth-child(4n))::after {\n    opacity: 0;\n  }\n\n  .ops-kpi:nth-child(odd)::after {\n    top: 22%;\n    bottom: 22%;\n    right: 0;\n    width: 1px;\n    opacity: 1;\n    background: linear-gradient(\n      to bottom,\n      transparent 0%,\n      rgba(143, 155, 175, 0.22) 25%,\n      rgba(143, 155, 175, 0.22) 75%,\n      transparent 100%\n    );\n  }\n\n  .ops-kpi:not(:nth-last-child(-n + 2))::before {\n    left: 14%;\n    right: 14%;\n    bottom: 0;\n    height: 1px;\n    opacity: 1;\n    background: linear-gradient(\n      to right,\n      transparent 0%,\n      rgba(143, 155, 175, 0.22) 20%,\n      rgba(143, 155, 175, 0.22) 80%,\n      transparent 100%\n    );\n  }\n\n  .ops-dash {\n    overflow: auto;\n    grid-template-columns: 1fr;\n    grid-template-rows: none;\n    grid-template-areas:\n      \"hero\"\n      \"kpis\"\n      \"queue\"\n      \"enroll\"\n      \"right\";\n  }\n\n  .ops-dash-right {\n    grid-template-columns: 1fr;\n    grid-template-rows: none;\n    grid-template-areas:\n      \"enrollments\"\n      \"collections\"\n      \"free\";\n    height: auto;\n    overflow: visible;\n  }\n\n  .ops-free-grid,\n  .ops-engage-lists {\n    grid-template-columns: 1fr;\n  }\n\n  .ops-panel {\n    overflow: visible;\n    height: auto;\n  }\n\n  .ops-enroll-hero {\n    align-items: flex-start;\n  }\n\n  .ops-enroll-hero-copy {\n    padding-top: 0;\n    align-self: flex-start;\n  }\n\n  .ops-teacher-pie-pair {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .ops-teacher-pie-viz {\n    --pie-size: min(140px, 40vw);\n  }\n\n  .ops-teacher-pie-key {\n    grid-template-columns: 1fr;\n  }\n\n  .ops-enroll-bottom {\n    grid-template-columns: 1fr;\n  }\n\n  .ops-enroll-bottom .ops-enroll-block:first-child {\n    padding-right: 0;\n  }\n\n  .ops-enroll-bottom .ops-enroll-block:last-child {\n    padding-left: 0;\n    border-left: none;\n    padding-top: 8px;\n    border-top: 1px solid rgba(143, 155, 175, 0.14);\n  }\n}\n\n@media (max-width: 720px) {\n  .admin-dashboard-shell {\n    position: relative;\n    height: auto;\n    overflow: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
